import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { FinanceAccessSlider, FinanceAccessTextContent } from './parts';

import { JSX } from 'react';
import styles from './styles.module.scss';

export type FinanceAccessProps =
  SliceComponentProps<Content.FinanceAccessSlice>;

const FinanceAccess = ({ slice }: FinanceAccessProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={styles.section}
      id={slice.id}
    >
      <FinanceAccessTextContent
        title={slice.primary.title}
        subtitle={slice.primary.subtitle}
        buttonText={slice.primary.button_text}
        buttonLink={slice.primary.button_link}
      />
      <FinanceAccessSlider items={slice.primary.cards} />
    </section>
  );
};

export default FinanceAccess;
